import { Button, Callout } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { DrupalRequestTypeDto, ERequestType, RequestApi } from "../../../../api";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { DrupalColors } from "../../../DrupalColors";
import { IconLink } from "./IconLink";
import { useRequest } from "ahooks";
import { isBrcs } from "../../../DrupalApp";

export interface IDrupalNewRequestPageProps {}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  & .vertical {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: center;
    & > * + * {
      margin-top: 1rem;
    }
  }

  & .content {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    & > * + * {
      margin-top: 1rem;
    }
    & .inner-title {
      color: ${DrupalColors.blue};
      font-size: 24px;
      letter-spacing: 3px;
    }

    & .inner-subtitle {
      font-weight: bold;
    }

    & .links {
      & > * + * {
        margin-top: 0.5rem;
      }
    }
  }
`;

export const DrupalNewRequestPage: React.FunctionComponent<IDrupalNewRequestPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(RequestApi);

  const getRequestTypeName = React.useCallback(
    (rt: DrupalRequestTypeDto) => {
      if (rt.requestTypeCode === ERequestType.BroodRequest) {
        return t(ETLCodes.BroodAndBirthRequest);
      }
      return rt.name;
    },
    [t]
  );

  const { data: requestTypes, loading } = useRequest(() => api.getDrupalRequestTypes(isBrcs));
  return (
    <Container>
      <div className="vertical">
        <DrupalFieldSet title={<div style={{ fontSize: 40, fontWeight: "bold" }}>{t(ETLCodes.NewRequest)}</div>}>
          <Callout intent="primary" icon={null}>
            <div className="content">
              <div className="inner-title">{t(ETLCodes.RequestType)}</div>
              <div className="inner-subtitle">{t(ETLCodes.PleaseSelectRequestType)}</div>
              <div className="links">
                {!loading &&
                  requestTypes.map((rt, key) => (
                    <IconLink text={getRequestTypeName(rt)} key={key} requestType={rt.requestTypeCode} />
                  ))}
              </div>
            </div>
          </Callout>
        </DrupalFieldSet>
        <div style={{ display: "flex" }}>
          <Button
            text={t(ETLCodes.General_GoBack)}
            onClick={() => history.goBack()}
            icon={IconNames.CHEVRON_LEFT}
            loading={loading}
            intent="primary"
            outlined={true}
            large={true}
          />
        </div>
      </div>
    </Container>
  );
};
